import React from 'react';
import Header from './shared/Header';
import { useRandomLinkColors } from '../utils/useRandomLinkColors';
import { getRandomColor } from '../utils/colors';
const WinterPracticeWorkshopPage = () => {
  useRandomLinkColors();
  return <div className="min-h-screen bg-[#faf9f7] text-[#333333] font-serif" data-id="element-626">
      <Header data-id="element-627" />
      <main className="flex min-h-screen pt-24 px-6 pb-16" data-id="element-628">
        {/* Mobile Layout */}
        <div className="md:hidden w-full max-w-2xl mx-auto" data-id="element-629">
          <h1 className="text-4xl font-bold mb-8 leading-tight" data-id="element-630">
            The Winter Practice Workshop
          </h1>

          <div className="text-base mb-8" data-id="element-631">
            <div className="font-bold mb-2" data-id="element-632">Dates:</div>
            <div data-id="element-633">Starts 24th January, 2026</div>
            <div data-id="element-634">Five Weeks, 3-Hours Per Week</div>
            <div className="mb-4" data-id="element-635">Saturday's from 9am - 12 pm EST</div>

            <div className="font-bold mb-2" data-id="element-636">Location:</div>
            <div data-id="element-637">All sessions will take place over Zoom.</div>
            <div className="mb-4" data-id="element-638">
              Class recordings and weekly assignments will be shared via email
              at the end of each week.
            </div>

            <div data-id="element-639">Workshop Fee: $375 USD</div>
            <div className="mb-4" data-id="element-640">Refunds up to 30 days before event.</div>

            <div className="mb-4" data-id="element-641">Workshop limited to 12 attendees.</div>

            <div className="text-base" data-id="element-642">
              <span className="font-bold text-[#333333] line-through" data-id="element-643">
                SOLD OUT
              </span>{' '}
              <span className="italic text-[#333333]" data-id="element-644">
                *
                <a href="mailto:mm@madeleinemorlet.com" className="transition-colors duration-200" onMouseEnter={e => {
                e.currentTarget.style.color = getRandomColor();
              }} onMouseLeave={e => {
                e.currentTarget.style.color = '#333333';
              }} data-id="element-645">
                  email
                </a>{' '}
                for waitlist
              </span>
            </div>
          </div>

          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/pbeQ5zz7K1Hno1NcmsjwBC/Madeleine-Morlet_10_copy_2.jpg" alt="Morning light through curtained windows" className="w-full h-auto mb-8" data-id="element-646" />

          <div className="text-base leading-relaxed space-y-4 mb-8" data-id="element-647">
            <div className="font-bold mb-2" data-id="element-648">Workshop:</div>
            <p data-id="element-649">
              This winter workshop is designed to throw fresh logs on the fire
              of your creative practice during the year's most introspective
              months. Blending artistic process, habit-building, and group
              critique, the format draws inspiration from Julia Cameron's{' '}
              <em data-id="element-650">The Artist's Way</em> and early methodologies of the Iowa
              Writers' Workshop (where students present their work for
              discussion without explanation, allowing them to 'see' it as
              others do). The aim is to help you establish a repeatable and
              generative rhythm that cycles between writing and
              photography—supporting the development of a daily creative routine
              or strengthening the one you already have.
            </p>
            <p data-id="element-651">
              Each session includes a lecture on a key theme, followed by a
              group critique. Participants are welcome to bring an existing
              project or begin something new, and will introduce their practices
              during the first week. Lectures will explore new entry points into
              photography through art, cinema, and literature, alongside
              carefully selected examples of images and writing that encourage
              awe, curiosity, and connection. Weekly assignments will consist of
              a short reading, a writing prompt, and a shooting task.
            </p>
            <p data-id="element-652">
              Where creative habits often lose momentum in the winter, this
              workshop offers structure, accountability, and the support of a
              thoughtful cohort. It is ideal for photographers of any ability or
              discipline who are interested in evolving their practices.
              Students can expect a busy and productive five weeks, engaging in
              writing and image-making that are both confidence-building and
              deeply satisfying. At the heart of the workshop is a spirit of
              playful inquiry, one that leaves participants with a renewed sense
              of purpose—ready to carry them into spring.
            </p>
          </div>

          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/dcDGGrrwFtUCkeLK9Mn7qj/Madeleine-Morlet_Headshot.jpg" alt="Madeleine Morlet" className="w-32 h-auto mb-4" data-id="element-653" />

          <div className="text-base leading-relaxed" data-id="element-654">
            <div className="font-bold mb-2" data-id="element-655">Instructor:</div>
            <p data-id="element-656">
              Madeleine Morlet is a British-American photographer based in
              London. Her teaching centers on the narrative potential of
              photography and the photobook form, informed by her background in
              filmmaking and creative writing. She combines editorial feedback
              with practical strategy to help students both refine their vision
              and sustain creative practices, guiding them toward publication.
              An award-winning photographer recognised by institutions including
              PhotoVogue and the Lucie Foundation, she brings both professional
              experience and artistic insight into the classroom.
            </p>
          </div>
        </div>

        {/* Desktop Layout */}
        <div className="hidden md:flex flex-row w-full max-w-6xl mx-auto gap-12" data-id="element-657">
          <div className="w-full md:w-1/2 flex flex-col gap-8" data-id="element-658">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/pbeQ5zz7K1Hno1NcmsjwBC/Madeleine-Morlet_10_copy_2.jpg" alt="Morning light through curtained windows" className="w-full h-auto" data-id="element-659" />

            <div className="flex-1 flex flex-col justify-end" data-id="element-660">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/dcDGGrrwFtUCkeLK9Mn7qj/Madeleine-Morlet_Headshot.jpg" alt="Madeleine Morlet" className="w-32 h-auto mb-4" data-id="element-661" />

              <div className="text-base leading-relaxed" data-id="element-662">
                <div className="font-bold mb-2" data-id="element-663">Instructor:</div>
                <p data-id="element-664">
                  Madeleine Morlet is a British-American photographer based in
                  London. Her teaching centers on the narrative potential of
                  photography and the photobook form, informed by her background
                  in filmmaking and creative writing. She combines editorial
                  feedback with practical strategy to help students both refine
                  their vision and sustain creative practices, guiding them
                  toward publication. An award-winning photographer recognised
                  by institutions including PhotoVogue and the Lucie Foundation,
                  she brings both professional experience and artistic insight
                  into the classroom.
                </p>
              </div>
            </div>
          </div>

          <div className="w-full md:w-1/2" data-id="element-665">
            <div className="max-w-2xl" data-id="element-666">
              <h1 className="text-4xl md:text-5xl font-bold mb-8 leading-tight" data-id="element-667">
                The Winter Practice Workshop
              </h1>

              <div className="text-base mb-8" data-id="element-668">
                <div className="font-bold mb-2" data-id="element-669">Dates:</div>
                <div data-id="element-670">Starts 24th January, 2026</div>
                <div data-id="element-671">Five Weeks, 3-Hours Per Week</div>
                <div className="mb-4" data-id="element-672">Saturday's from 9am - 12 pm EST</div>

                <div className="font-bold mb-2" data-id="element-673">Location:</div>
                <div data-id="element-674">All sessions will take place over Zoom.</div>
                <div className="mb-4" data-id="element-675">
                  Class recordings and weekly assignments will be shared via
                  email at the end of each week.
                </div>

                <div data-id="element-676">Workshop Fee: $375 USD</div>
                <div className="mb-4" data-id="element-677">Refunds up to 30 days before event.</div>

                <div className="mb-4" data-id="element-678">Workshop limited to 12 attendees.</div>

                <div className="text-base" data-id="element-679">
                  <span className="font-bold text-[#333333] line-through" data-id="element-680">
                    SOLD OUT
                  </span>{' '}
                  <span className="italic text-[#333333]" data-id="element-681">
                    *
                    <a href="mailto:mm@madeleinemorlet.com" className="transition-colors duration-200" onMouseEnter={e => {
                    e.currentTarget.style.color = getRandomColor();
                  }} onMouseLeave={e => {
                    e.currentTarget.style.color = '#333333';
                  }} data-id="element-682">
                      email
                    </a>{' '}
                    for waitlist
                  </span>
                </div>
              </div>

              <div className="text-base leading-relaxed space-y-4" data-id="element-683">
                <div className="font-bold mb-2" data-id="element-684">Workshop:</div>
                <p data-id="element-685">
                  This winter workshop is designed to throw fresh logs on the
                  fire of your creative practice during the year's most
                  introspective months. Blending artistic process,
                  habit-building, and group critique, the format draws
                  inspiration from Julia Cameron's <em data-id="element-686">The Artist's Way</em> and
                  early methodologies of the Iowa Writers' Workshop (where
                  students present their work for discussion without
                  explanation, allowing them to 'see' it as others do). The aim
                  is to help you establish a repeatable and generative rhythm
                  that cycles between writing and photography—supporting the
                  development of a daily creative routine or strengthening the
                  one you already have.
                </p>
                <p data-id="element-687">
                  Each session includes a lecture on a key theme, followed by a
                  group critique. Participants are welcome to bring an existing
                  project or begin something new, and will introduce their
                  practices during the first week. Lectures will explore new
                  entry points into photography through art, cinema, and
                  literature, alongside carefully selected examples of images
                  and writing that encourage awe, curiosity, and connection.
                  Weekly assignments will consist of a short reading, a writing
                  prompt, and a shooting task.
                </p>
                <p data-id="element-688">
                  Where creative habits often lose momentum in the winter, this
                  workshop offers structure, accountability, and the support of
                  a thoughtful cohort. It is ideal for photographers of any
                  ability or discipline who are interested in evolving their
                  practices. Students can expect a busy and productive five
                  weeks, engaging in writing and image-making that are both
                  confidence-building and deeply satisfying. At the heart of the
                  workshop is a spirit of playful inquiry, one that leaves
                  participants with a renewed sense of purpose—ready to carry
                  them into spring.
                </p>
              </div>
            </div>
          </div>
        </div>
      </main>
    </div>;
};
export default WinterPracticeWorkshopPage;